/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Initial_Role_NameInputs */

const en_admin_settings_fields_initial_role_name = /** @type {(inputs: Admin_Settings_Fields_Initial_Role_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default role name`)
};

const zh_admin_settings_fields_initial_role_name = /** @type {(inputs: Admin_Settings_Fields_Initial_Role_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`默认角色名称`)
};

/**
* | output |
* | --- |
* | "Default role name" |
*
* @param {Admin_Settings_Fields_Initial_Role_NameInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_initial_role_name = /** @type {((inputs?: Admin_Settings_Fields_Initial_Role_NameInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Initial_Role_NameInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_initial_role_name(inputs)
	return zh_admin_settings_fields_initial_role_name(inputs)
});
export { admin_settings_fields_initial_role_name as "admin.settings.fields.initial_role_name" }